import { inject, Injectable } from '@angular/core';
import { CanDeactivate, Router } from '@angular/router';
import { Observable, isObservable } from 'rxjs';
import { AuthenticationService } from '../../features/authentication/services/authentication.service';

export interface CanComponentDeactivate {
  canDeactivate: () => Observable<boolean> | Promise<boolean> | boolean;
}

@Injectable({
  providedIn: 'root'
})
export class UnsavedChangesGuard implements CanDeactivate<CanComponentDeactivate> {
  private readonly router = inject(Router);
  private readonly authenticationService = inject(AuthenticationService);
  constructor() {}

  canDeactivate(component: CanComponentDeactivate): Observable<boolean> | Promise<boolean> | boolean {
    // Session expired: interceptor already cleared localStorage before navigating to login.
    // Skip the unsaved-changes dialog so the user goes directly to the login page.
    if (this.authenticationService.isTokenExpired()) {
      return true;
    }

    if (localStorage.getItem('logout') === 'true') {
      localStorage.removeItem('logout');
      return true;
    }

    const canLeave = component.canDeactivate ? component.canDeactivate() : true;

    if (isObservable(canLeave)) {
      return canLeave;
    }

    if (canLeave instanceof Promise) {
      return canLeave.then((result) => {
        if (!result) {
          this.router.navigateByUrl(this.router.url);
        }
        return result;
      });
    } else {
      if (!canLeave) {
        this.router.navigateByUrl(this.router.url);
      }
      return canLeave;
    }
  }
}
